import { createFileRoute } from "@tanstack/react-router";

import { DriversAdminPage } from "./_app.erp.settings.drivers";

export const Route = createFileRoute("/_app/settings/drivers")({
  component: DriversAdminPage,
});
